"use strict";
function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function (value, key) {
        result[++index] = [key, value];
    });
    return result;
}
module.exports = mapToArray;
//# sourceMappingURL=_mapToArray.js.map